import React from 'react';
import { graphql } from 'gatsby';
import { normalizeBlockContentNodes } from '@blocks-helpers';
import BasePage from '@elegantstack/solid-ui-blocks/src/BasePage';
import IndustryBlock from '@solid-ui-blocks/IndustryBlock/Block06';
import { css } from 'theme-ui';
import Divider from '@solid-ui-components/Divider/Divider';
import GetStarted from '@solid-ui-blocks/Features/Block07';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper/LayoutWrapper';
import ManagementFeatures from '@solid-ui-blocks/ManagementFeatures/ManagementFeatures';
import FeaturesBlock from '@solid-ui-blocks/Features/Block11';
import FeaturesTabOne from '@solid-ui-blocks/FeaturesWithPhoto/Block07';

const styles = {
  ellipse: {
    position: 'absolute',
    left: 0,
    top: '275px',
    width: '100%',
    height: ['430px', '440px', '450px', '370px'],
    background: 'linear-gradient(0deg, #F0F9FF 13%, #FFFFFF 100%)',
    clipPath: ['ellipse(100% 100% at top)', 'ellipse(160% 100% at top)', 'ellipse(100% 100% at top)', 'ellipse(100% 100% at top)'],
    zIndex: '-10',
  },
};

const Restaurant = (props) => {
  const {
    data: { allBlockContent },
    location: { pathname },
  } = props;
  const content = normalizeBlockContentNodes(allBlockContent?.nodes);

  return (
    <BasePage
      keywords={'restaurant management app, restaurant management software, restaurant checklist, restaurant cleaning checklist, restaurant task management, restaurant management programs, hospitality restaurant management'.split(
        ', '
      )}
      description={
        'Free Task Management Software for HoReCa: Optimize Operations and Inspections. Enhance efficiency with scheduling, checklists, incident reporting, and QR codes.'
      }
      title='Robust Restaurant Task Management App'
      pathname={pathname}
      {...props}
    >
      <div css={css(styles.ellipse)}></div>
      <LayoutWrapper>
        <FeaturesTabOne
          customButton
          content={content['features-tab-one']}
          reverse
        />
        <Divider />
        <FeaturesBlock content={content['advantages']} />
        <ManagementFeatures content={content['management-features']} />
        <IndustryBlock content={content} />
        <Divider space={7} />
        <GetStarted content={content['get-started']} />
      </LayoutWrapper>
      <Divider space={7} />
    </BasePage>
  );
};

export const query = graphql`
  query restaurantManagementTargPatrolEnBlockContent {
    allBlockContent(filter: { page: { in: ["targpatrol-en/restaurant"] } }) {
      nodes {
        ...BlockContent
      }
    }
  }
`;

export default Restaurant;
